import styled from "@emotion/styled";

export const SystemSettingsContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const SettingsSection = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  border-radius: 6px;
  padding: 30px;
  display: flex;
  align-items: start;
  width: 70%;
  height: 424px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RowSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid lightgray;
  margin: 15px 0 15px 0;
`;

export const Section = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const VerticalDivider = styled.div`
  background-color: ${({ theme }) => theme.colors.main[9]};
  width: 2px;
  height: 100%;
  margin: 0 30px 0 30px;
`;
